import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Playout } from '../../../interfaces/playout';
import { Playlist } from 'app/interfaces/playlist';


@Component({
	selector: 'playlist-details-embed',
	templateUrl: './playlist-details-embed.component.html',
	styleUrls: ['./playlist-details-embed.component.scss']
})

export class PlaylistDetailsEmbedComponent implements OnInit, OnDestroy {
	@Input() playlist: Playlist;
	@Input() form: NgForm;
	@Input() isActive: boolean;

	@Output() onPlayoutChange: EventEmitter<Playout>;

	constructor() {
		this.onPlayoutChange = new EventEmitter<Playout>();
	}

	ngOnInit() {
	}

	ngOnDestroy() {
	}

	onPlayoutChanged(playout: Playout) {
		this.onPlayoutChange.emit(playout);
	}
}
